module.exports = __webpack_public_path__ + "static/media/Futura_Condensed_Bd.904b1c47.ttf";